import _ from 'lodash';
import { makeAutoObservable } from 'mobx';
import CompanyDocumentViewModel from 'main/stores/documents/CompanyDocumentViewModel';
import {t} from 'shared/core';

class PendingDocumentsState {
  match;

  documentViewModels = [];
  errors = {};

  constructor(store, match) {
    makeAutoObservable(this);

    this.store = store;
    this.match = match;
  }

  async load() {
    const response = await this.store.loadPendingDocument(this.match.params.id);
    this.handleResponse(response);
  }

  handleResponse(response) {
    if (_.get(response, 'response.status') === 404) {
      this.errors.document = t('onboard.documents.errors.This document is not available.');
    } else {
      const companyDocument = new CompanyDocumentViewModel(response);
      this.documentViewModels.push(companyDocument);
    }
  }

  onAllDocumentsCompleted() {
    window.location.href = '/inbox';
  }
}

export default PendingDocumentsState;
